import { Component, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-tabs',
    templateUrl: './tabs.component.html',
    styleUrls: ['./tabs.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatRippleModule,
        NgClass,
        MatBadgeModule,
        MatTooltipModule,
        TranslateModule,
    ],
})
export class TabsComponent {
    @Output() changed = new EventEmitter<any>();

    @Input() tabs: string[];
    @Input() tabsInfo: any;

    @Input() selectedTab: string;

    constructor() {}
    public changeTab(tab: string) {
        this.selectedTab = tab;
        this.changed.emit(tab);
    }

    public getTabBadgeInfo(tab: string) {
        return this.tabsInfo[tab];
    }

    public getTabTooltip(tab: string): string {
        switch (tab) {
            case 'active-deviations':
                return 'Active deviations';
            case 'coming-deviations':
                return 'Coming deviations';
            case 'expired-deviations':
                return 'Expired deviations';
            case 'vehicles':
                return 'Vehicle list';
            case 'line-view':
                return 'Line view';
            default:
                return '';
        }
    }

    public getTabIcon(tab: string): string {
        switch (tab) {
            case 'overview':
                return 'fas fa-eye';
            case 'notes':
                return 'fas fa-sticky-note';
            case 'settings':
                return 'fas fa-cog';
            case 'vehicleinfo':
                return 'fas fa-info-circle';
            case 'analytics':
                return 'fas fa-chart-bar';
            case 'screenshots':
                return 'fas fa-camera';
            case 'debug':
                return 'fas fa-code';
            case 'vehicles':
                return 'fa-solid fa-bus-simple';
            case 'block':
                return 'fas fa-circle-notch';
            case 'soc':
                return 'fas fa-battery-full';
            case 'warnings':
                return 'fas fa-exclamation-triangle';
            case 'active-deviations':
                return 'fa-solid fa-file-lines';
            case 'coming-deviations':
                return 'fa-solid fa-calendar-days';
            case 'expired-deviations':
                return 'fas fa-history';
            case 'line-view':
                return 'fas fa-route';
            case 'signon':
                return 'fa-solid fa-wifi';    
            default:
                return '';
        }
    }
}
